import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';

interface AddToActionPlanButtonProps {
  section: string;
  className?: string;
}

export function AddToActionPlanButton({ section, className }: AddToActionPlanButtonProps) {
  const handleClick = () => {
    toast.success('Added to Action Plan', {
      description: `"${section}" has been added to your action plan.`,
      duration: 3000,
    });
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      className={className}
    >
      <Plus className="h-4 w-4 mr-2" />
      Add to Action Plan
    </Button>
  );
}